import LoadingOverlay from 'components/LoadingOverlay';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router';
import WebStorage from 'services/WebStorage';

@inject('user')
@observer
class CallbackComponent extends React.Component {
  constructor(props) {
    super(props);
    this.storage = new WebStorage();
  }

  componentDidMount() {
    this.props.user.manager
      .signinRedirectCallback()
      .then(async (user) => await this.onRedirectSuccess(user))
      .catch((error) => this.onRedirectError(error));
  }

  onRedirectSuccess = async (user) => {
    let origin = await this.storage.get('origin');
    await this.storage.remove('origin');

    const url = new URL(origin);
    url.searchParams.delete('idp');

    this.props.history.push(`${url.pathname}${url.search}`);
  };

  onRedirectError = (error) => {
    if (this.props.errorCallback) {
      this.props.errorCallback(error);
    } else {
      throw new Error(`Error handling redirect callback: ${error.message}`);
    }
  };

  render() {
    return <LoadingOverlay isVisible={true} fullscreen={true} />;
  }
}

export default withRouter(CallbackComponent);



// WEBPACK FOOTER //
// ./src/app/containers/Callback/index.jsx